import React, { FC } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useIntl } from 'react-intl';
import { constants } from 'src/app/common/constants';
import { PruDatePicker } from 'src/app/common/components/PruDatePicker';
import Form from 'src/app/common/components/Form';
import { DisplayFormatEnum, KeyTaskConfiguration } from '../../../../types/key-task-summarizer-type';
import { ConfigurationRules } from '../keyTaskSummarizerDetailForm.rules';

type TimetableFieldsProps = {
  isDisabled: boolean;
  configurationRules: (field: keyof KeyTaskConfiguration) => ConfigurationRules;
};

const TimetableFields: FC<TimetableFieldsProps> = ({ isDisabled, configurationRules }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <>
      <Form.Item
        name="countdownDate"
        label={Translation('KeyTaskSummerizer.countdown_date')}
        dependencies={['effectiveRange']}
        rules={configurationRules('countdownDate')}
      >
        {(control) => (
          <PruDatePicker
            value={control.value}
            disabled={isDisabled}
            format={constants.Default_Date_Format}
            onChange={(countdownDate) => {
              control.onChange(countdownDate);
            }}
            slotProps={{
              textField: {
                margin: 'dense',
                inputProps: { 'aria-label': Translation('KeyTaskSummerizer.countdown_date') },
              },
            }}
          />
        )}
      </Form.Item>
      <Form.Item
        name="displayFormat"
        label={Translation('KeyTaskSummerizer.display_format')}
        rules={configurationRules('displayFormat')}
      >
        <RadioGroup
          row
          aria-label={Translation('KeyTaskSummerizer.display_format')}
        >
          <FormControlLabel
            value={DisplayFormatEnum.DISPLAY_DATE}
            control={<Radio disabled={isDisabled} />}
            label={Translation('KeyTaskSummerizer.format_date')}
          />
          <FormControlLabel
            value={DisplayFormatEnum.COUNTDOWN_DAYS}
            control={<Radio disabled={isDisabled} />}
            label={Translation('KeyTaskSummerizer.format_countdown')}
          />
        </RadioGroup>
      </Form.Item>
    </>
  );
};

export default TimetableFields;
